import colors from 'styles/sass-variables.module.scss';

const accountButton: Record<string, string | object> = {
  color: colors.text_grey,
  display: 'flex',
  maxWidth: '135px',
  padding: '0',
  fontWeight: '400',
  span: {
    width: '18px',
    height: '18px',
  },
  '&:hover, &:active': {
    color: colors.text_grey,
  },
};

const accountMenu: Record<string, string | object> = {
  backgroundColor: colors.white,
  padding: '4px',
  width: '200px',
  position: 'fixed',
  right: '24px',
  top: '63px',
  borderRadius: '8px',
  boxShadow: '4px 4px 4px 0px rgba(62, 59, 81, 0.06), -4px 0px 4px 0px rgba(62, 59, 81, 0.06)',
  zIndex: '23',
  '.MuiDivider-fullWidth': {
    margin: '0',
    borderColor: colors.greys_border,
  },
};

const accountMenuItem: Record<string, string | object> = {
  borderRadius: '6px',
  '&:not(:last-child)': {
    marginBottom: '4px',
  },
  '&:last-child': {
    marginTop: '4px',
  },
  '&:hover, &:active': {
    backgroundColor: colors.primary_purple_100,
  },
};

const accountMenuButton: Record<string, string | object> = {
  color: colors.greys_black,
  padding: '8px 16px',
  lineHeight: '1.4',
  fontWeight: '400',
  justifyContent: 'left',
  textAlign: 'start',
  textTransform: 'capitalize',
  span: {
    width: '20px',
    height: '20px',
    marginLeft: 'auto',
  },
  '&:hover, &:active': {
    color: colors.greys_black,
  },
};

export const accountSettingsStyles = {
  accountButton,
  accountMenu,
  accountMenuItem,
  accountMenuButton,
};
